<template>
  <div>
    <span class="sm-notification__inner">
      <include-svg :name="'icon-warning'" />
      <span>You haven't signed California B&P Code § 17538.5 Acknowledgment</span>
      <a
        href="#"
        class="sm-txt-strong"
        @click.prevent="signCADocument"
      >Sign now</a>
    </span>
  </div>
</template>

<script>
import IncludeSvg from '@/components/IncludeSvg.vue';
import Btn from '@/components/Buttons.vue';

export default {
  name: 'ca-acknowledgment-notification',
  components: {
    "include-svg": IncludeSvg,
    "btn-block": Btn,
  },
  methods: {
    signCADocument() {
      // window.open(Urls.external.notary_service, '_blank', {width: '100%'});
      this.$router.push(`/customer/account?notary_type=sign-ca`);
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;

  .sm-notification__inner {
    display: flex;
    align-items: center;
    justify-content: center;

    @include media('<=tiny') {
      flex-wrap: wrap;
    }

    & > svg {
      margin-right: 5px;
    }

    & > a {
      display: flex;
      margin-left: 25px;
      padding: 2px 8px;
      color: var(--text);
      background-color: var(--yellow-2);
      border-radius: 4px;
      transition: opacity 0.2s ease;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.6;
      }

      @include media('<=tiny') {
        justify-content: center;
        width: 100%;
        margin-left: 0;
        margin-top: 5px;
        text-align: center;
      }
    }
  }
</style>